<template>
  <div class="grid grid-cols-12 text-xs text-gray-600 gap-x-4 p-4 items-end">
    <div class="col-span-9">Description</div>
    <div class="col-span-2 text-right">Amount</div>
  </div>
</template>

<script>
export default {
  //
};
</script>
